import React, { useState } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import "bootstrap-icons/font/bootstrap-icons.css";

const StyledSideNav = styled.aside.withConfig({
  shouldForwardProp: (prop) => prop !== "collapsed",
})`
  background-color: rgb(99 102 241);
  color: #fff;
  height: 100vh;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 3rem;
  width: ${(props) => (props.collapsed ? "60px" : "250px")};
  transition: width 0.3s ease;
  overflow: hidden;

  .toggle-btn {
    display: none;
    background: none;
    border: none;
    color: white;
    font-size: 1.5rem;
    cursor: pointer;
    align-self: flex-end;

    @media (max-width: 768px) {
      display: block;
    }
  }

  .title {
    display: flex;
    align-items: center;
    justify-content: ${(props) => (props.collapsed ? "center" : "flex-start")};
    gap: 0.5rem;
    font-size: 1.5rem;
    font-weight: bold;

    i {
      font-size: 1.5rem;
    }

    span {
      display: ${(props) => (props.collapsed ? "none" : "inline")};
    }
  }

  ul {
    list-style: none;
    padding: 0;

    li {
      margin-bottom: 2.5rem;

      .nav-link {
        color: #fff;
        text-decoration: none;
        display: flex;
        align-items: center;
        gap: 0.5rem;
        font-size: 1.1rem;
        font-weight: bold;

        &:hover {
          color: black;
        }

        span {
          display: ${(props) => (props.collapsed ? "none" : "inline")};
        }
      }
    }
  }

  @media (max-width: 768px) {
    position: fixed;
    height: 100%;
    z-index: 1000;
  }
`;

function SideNav() {
  const [collapsed, setCollapsed] = useState(false);

  const toggleMenu = () => {
    setCollapsed(!collapsed);
  };

  return (
    <StyledSideNav collapsed={collapsed}>
      <button className="toggle-btn" onClick={toggleMenu}>
        <i
          className={`bi ${collapsed ? "bi-chevron-right" : "bi-chevron-left"}`}
        ></i>
      </button>
      <div className="title">
        <span>Task Manager</span>
      </div>
      <ul>
        <li>
          <Link to="/" className="nav-link">
            <i className="bi bi-speedometer2"></i> <span>Dashboard</span>
          </Link>
        </li>
        <li>
          <Link to="/AddTaskPage" className="nav-link">
            <i className="bi bi-plus-circle"></i> <span>Add New Tasks</span>
          </Link>
        </li>
        <li>
          <Link to="/CompletedTaskPage" className="nav-link">
            <i className="bi bi-check-circle"></i> <span>Completed Tasks</span>
          </Link>
        </li>
        <li>
          <Link to="/PendingTaskPage" className="nav-link">
            <i className="bi bi-exclamation-circle"></i>{" "}
            <span>Pending Tasks</span>
          </Link>
        </li>
        <li>
          <Link to="/Categories" className="nav-link">
            <i className="bi bi-plus-circle"></i> <span> Categories</span>
          </Link>
        </li>
      </ul>
    </StyledSideNav>
  );
}

export default SideNav;
